import { render, staticRenderFns } from "./ExamPlan.vue?vue&type=template&id=fda86dc4&scoped=true"
import script from "./ExamPlan.vue?vue&type=script&lang=js"
export * from "./ExamPlan.vue?vue&type=script&lang=js"
import style0 from "./ExamPlan.vue?vue&type=style&index=0&id=fda86dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda86dc4",
  null
  
)

export default component.exports